<template>
  <el-table :data="pileDataTable" stripe style="width: 100%" ref="pileDataTable" border
            v-loading="listLoading">
    <af-table-column prop="id" :label="$t('fei-shuai-bian-hao')"/>
    <af-table-column prop="name" :label="$t('fei-shuai-ming-cheng')"/>
    <af-table-column prop="operatorName" :label="$t('suo-shu-yun-ying-shang-0')"/>
    <af-table-column prop="type.message" :label="$t('ji-fei-lei-xing')"/>
    <af-table-column prop="scooterRateDetailList[0].electricPrice" :label="$t('siteManager.unitPrice2')" width="90" />
    <af-table-column prop="scooterRateDetailList[0].servicePrice" :label="$t('siteManager.unitPrice2')" width="90" />
    <!--<af-table-column label="电费" width="380" >
      <template slot-scope="scope" v-if="scope.row.type && scope.row.scooterRateDetailList && scope.row.scooterRateDetailList.length > 0">
        <div v-if="scope.row.type.code === 2">
          <div v-for="item in scope.row.scooterRateDetailList">
            <span style="color: #409EFF;" class="span">●</span>
            <span v-html="'最大功率: ' + item.powerMax + '/kW·h 电费：' + item.electricPrice + ' 元/h'"></span><br/>
          </div>
        </div>
        <div v-else>
          <span style="color: #409EFF;" class="span">●</span>
          <span v-html="' 电费 : ' + scope.row.scooterRateDetailList[0].electricPrice + ' 元/kW·h'"></span>
        </div>
      </template>
    </af-table-column>
    <af-table-column prop="serviceFees" label="服务费" width="380" >
      <template slot-scope="scope" v-if="scope.row.type && scope.row.scooterRateDetailList && scope.row.scooterRateDetailList.length > 0">
        <div  v-if="scope.row.type.code === 2">
          <div v-for="item in scope.row.scooterRateDetailList">
            <span style="color: #409EFF;" class="span">●</span>
            <span v-html="'最大功率: ' + item.powerMax + '/kW·h 服务费：' + item.servicePrice + ' 元/h'"></span><br/>
          </div>
        </div>
        <div v-else>
          <span style="color: #409EFF;" class="span">●</span>
          <span v-html="' 服务费 : ' + scope.row.scooterRateDetailList[0].servicePrice + ' 元/kW·h'"></span>
        </div>
      </template>
    </af-table-column>-->
    <af-table-column :label="$t('deviceControl.operation')" width="200">
      <template slot-scope="scope">
        <el-button size="mini" @click="pileEdit(scope.$index, scope.row)"  v-if="checkPermission(['bee:res:rate:scooterRateSave'])" >{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" type="danger"  v-if="checkPermission(['bee:res:rate:scooterRateDelete'])" @click="pileDelete(scope.$index, scope.row)">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{
      }
    },
    props:{
      pileDataTable:{},
      listLoading:false,
    },
    methods:{
      pileEdit(index,row){
        this.$emit("pileEdit",index,row)
      },
      pileDelete(index,row){
        this.$emit("pileDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/scooterRateManager/list.vue